import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var GraduationCap = function GraduationCap(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "graduation-cap-mask",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 1,
      y: 1,
      width: 19,
      height: 17,
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.028 1.763a.833.833 0 0 1 .776 0l7.917 4.166a.833.833 0 0 1 0 1.475l-2.055 1.082V15a.833.833 0 0 1-.244.59l-.59-.59.59.59h-.001l-.001.002-.003.003-.009.008a2.667 2.667 0 0 1-.115.107c-.075.067-.183.16-.322.27a8.941 8.941 0 0 1-1.192.79 8.978 8.978 0 0 1-4.363 1.147 8.978 8.978 0 0 1-4.363-1.147 8.945 8.945 0 0 1-1.192-.79 6.74 6.74 0 0 1-.411-.352l-.026-.025-.009-.008-.003-.003v-.002c-.001 0-.002 0 .587-.59l-.589.59a.833.833 0 0 1-.244-.59V8.486l-.833-.439v3.62a.833.833 0 1 1-1.667 0v-5a.83.83 0 0 1 .46-.746l7.902-4.158Zm.776 9.808L15 9.363v5.26a7.284 7.284 0 0 1-1.03.69 7.312 7.312 0 0 1-3.553.937 7.312 7.312 0 0 1-3.554-.937 7.282 7.282 0 0 1-1.03-.69v-5.26l4.196 2.208a.833.833 0 0 0 .776 0ZM4.29 6.667l6.127 3.225 6.127-3.225-6.127-3.225-6.127 3.225Z",
        fill: color
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#graduation-cap-mask)",
      children: /*#__PURE__*/_jsx("path", {
        fill: color,
        d: "M0 0h20v20H0z"
      })
    })]
  });
};
export default GraduationCap;